import { RIPPLING } from '@/integrations/modules/rippling/consts';
import type { RipplingPositionsData } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchRipplingPositions = createAsyncThunk('rippling/fetchPositions', async (_, { rejectWithValue }) => {
  try {
    const response = await Integrations.get(`/${RIPPLING}/v2/config/positions`);
    return response as { data: RipplingPositionsData };
  } catch (error) {
    return rejectWithValue(error);
  }
});
